import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',//登陆页面
    component: () => import('../views/login.vue')
  }, {
    path: '/goodsInfo',
    name: 'goodsInfo',//登陆页面
    component: () => import('../views/goodsInfo.vue')
  }, {
    path: '/index',
    name: 'index',// 系统主页面
    component: () => import('../views/index.vue')
  }, {
    path: '/goodsManage',
    name: 'goodsManage',// 商品管理页面
    component: () => import('../views/goodsManage.vue')
  }, {
    path: '/dictManage',
    name: 'dictManage',// 字典管理页面
    component: () => import('../views/dictManage.vue')
  }, {
    path: '/webUserManage',
    name: 'webUserManage',// web用户管理页面
    component: () => import('../views/webUserManage.vue')
  }, {
    path: '/wxUserManage',
    name: 'wxUserManage',// 微信用户管理页面
    component: () => import('../views/wxUserManage.vue')
  }, {
    path: '/commonOrderManage',
    name: 'commonOrderManage',// 普通订单管理页面
    component: () => import('../views/commonOrderManage.vue')
  }, {
    path: '/groupOrderManage',
    name: 'groupOrderManage',// 团购订单管理页面
    component: () => import('../views/groupOrderManage.vue')
  }, {
    path: '/configManage',
    name: 'configManage',// 配置管理页面
    component: () => import('../views/configManage.vue')
  }, {
    path: '/exchangeManage',
    name: 'exchangeManage',// 商品券兑换管理页面
    component: () => import('../views/exchangeManage.vue')
  }, {
    path: '/returnGoodsManage',
    name: 'returnGoodsManage',// 退货管理页面
    component: () => import('../views/returnGoodsManage.vue')
  },


  {
    path: '/mainPage',
    name: 'mainPage', //首页
    component: () => import('../views/mainPage.vue')
  }, {
    path: '/userInfo',
    name: 'userInfo',//个人信息页面
    component: () => import('../views/userInfo.vue')
  }, {
    path: '/classManage',
    name: 'classManage',//分类管理页面
    component: () => import('../views/classManage.vue')
  }, {
    path: '/resourceManage',
    name: 'resourceManage',//资源管理页面
    component: () => import('../views/resourceManage.vue')
  }, {
    path: '/courseManage',
    name: 'courseManage',//课程管理页面
    component: () => import('../views/courseManage.vue')
  }, {
    path: '/userManage',
    name: 'userManage',//用户管理页面
    component: () => import('../views/userManage.vue')
  }, {
    path: '/examineResource',
    name: 'examineResource',//资源审核页面
    component: () => import('../views/examineResource.vue')
  }, {
    path: '/myLikes',
    name: 'myLikes',//我的收藏页面
    component: () => import('../views/myLikes.vue')
  }, {
    path: '/myCourse',
    name: 'myCourse',//我的课程页面
    component: () => import('../views/myCourse.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
